import React, { memo, useContext, useEffect, useState } from "react";
import { Data } from "../App";
import { Link } from "react-router-dom";
import { Stock } from "../common/Icon";

function Selected() {
  const { selectedList, setSelectedList } = useContext(Data);
  const [show, setShow] = useState(false);
  const arr = [0, 1, 2, 3, 4];

  useEffect(() => {
    if (selectedList.length === 5) {
      setShow(true);
    }
  }, [selectedList]);

  return (
    <>
      <div
        className={
          show ? "selected_tab_container show" : "selected_tab_container"
        }
      >
        <div onClick={() => setShow(true)} className="bold">
          サンプル請求<b>{selectedList.length}</b>
        </div>
        <div>
          <p>
            最大5枚まで
            <br />
            お選びいただけます。
          </p>
          <ul>
            {arr.map((n, i) => {
              return (
                <li key={i}>
                  {selectedList[n] ? (
                    <>
                      <div>
                        <img
                          src={`/material/images/wave/thumb/${selectedList[n].code}.jpg`}
                          alt={selectedList[n].kiji}
                        />
                        <Stock data={selectedList[n].stock} />
                      </div>
                      <p>
                        {selectedList[n].kiji.split(" ")[0]}
                        <small>{selectedList[n].kiji.split(" ")[1]}</small>
                      </p>
                      <span
                        onClick={() =>
                          setSelectedList(
                            selectedList
                              .slice(0, n)
                              .concat(selectedList.slice(n + 1))
                          )
                        }
                      ></span>
                    </>
                  ) : (
                    <div>{n + 1}</div>
                  )}
                </li>
              );
            })}
          </ul>
          <Link to="/form/">
            <b>お届け先の入力</b>
          </Link>
          <a onClick={() => setShow(false)}>閉じる</a>
        </div>
      </div>
      {show ? (
        <div className="tab_bg" onClick={() => setShow(false)}></div>
      ) : null}
    </>
  );
}

export default memo(Selected);
